import { object, string, null as zNull, type infer as zInfer } from "zod/v4";

export const createParentEasypostIntegration = {
  name: "createParentEasypostIntegration" as const,
  input: object({ prodApiKey: string(), testApiKey: string() }),
  output: zNull(),
};

export type CreateParentEasypostIntegrationInput = zInfer<
  typeof createParentEasypostIntegration.input
>;
